import './contentModalVersementLivret.css';

export const ContentModalVersementLivret = (
  <p className="versement-livret-modale">
    Les versements sur un livret ne se font pas par prélèvement mais par virement bancaire.
    <span className="bolder-text">Vous devez donc effectuer le virement depuis votre compte de confiance</span>
    (celui que vous avez déclaré à la souscription ou tout autre compte ayant été déclaré par la suite sur votre espace
    client CFCAL).
  </p>
);
